import { Dispatch } from 'redux';
import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

/**
 * Says that the dropped files are on the server.
 *
 * An attachment is stored the moment it is dropped, by itself and without
 * "Speichern" — but nothing said so, so the key user saved the document
 * afterwards to be sure nothing was lost (GF 08.10.2026, #2230 P1). One
 * notice for the whole drop; a file that did not make it reports itself.
 */
export const noticeUploaded = async (dispatch: Dispatch, uploads: Promise<boolean>[]): Promise<void> => {
    const saved = (await Promise.all(uploads)).filter(Boolean).length;

    if (saved > 0) {
        dispatch(Snackbar.enqueue(PoolNotification.success('app.upload.saved', { count: saved })));
    }
};
